<template>
	<section
		class="card-wrapper"
		:id="item.campaignId"
		:data-article-category="className"
	>
		<router-link
			:to="`/campaign-editor-workspace/${
				item.campaignId
			}/${getDefaultPane()}`"
			:href="item"
			:aria-label="`view ${item.name}`"
			class="card-link"
			data-testid="campaign-card"
		>
			<img
				:src="item.previewUri"
				:alt="item.summary"
				class="card-image"
			/>
		</router-link>
		<h2 class="card-title">{{ item.name }}</h2>
		<p class="card-description">{{ item.summary }}</p>
	</section>
</template>

<script>
export default {
	name: 'CampaignCard',
	props: {
		item: Object,
		className: String,
	},
	methods: {
		getDefaultPane() {
			if (this.item.campaignId === 52) {
				return 'pricing';
			} else {
				return 'media';
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.variables {
	border: $b360-border-width-medium solid transparent;
	transition: all $b360-motion-duration--long $b360-motion-easing--accelerate;
	color: $brand-blue;
	border-radius: $b360-border-radius-base;
	border-radius: $border-radius;
	background-color: $b360-color--orange;
	color: $white;
	color: $subheader-color;
	color: $text-base-color;
}

.card-wrapper {
	display: flex;
	flex-direction: column;
	width: 200px;
	padding: 10px 5px 5px 5px;
	transition: all $b360-motion-duration--long $b360-motion-easing--accelerate;
}

.card-wrapper:hover {
	transform: scale(1.05);
}

.card-image {
	width: 100%;
	height: 200px;
	border-radius: $border-radius;
	cursor: pointer;
	object-fit: cover;
}

.card-title {
	@include rem(font-size, 17px);
	@include typo--roboto__medium;
	@include rem(line-height, 17px);
	@include rem(margin, 20px 0 10px 0);
	text-transform: capitalize;
	color: $subheader-color;
}

.card-description {
	@include rem(padding, 0 0 10px 0);
	@include rem(font-size, 15px);
	@include typo--roboto__regular;
	color: $text-base-color;
}
</style>
